module.exports = __webpack_public_path__ + "media/traitz-header.9abcb5b0.mp4";